import React from 'react';

import { DateRangePicker } from '@adsk/alloy-react-date-picker';
import { DatePickerAllArgs } from '@adsk/alloy-react-date-picker/es/types';

import { formatDateToUrl, parseDateFromUrl } from '../../utils/dateFormat';

type DateUrlProps = DatePickerAllArgs & {
  onChangeDate: (value?: string) => void;
  selectedValues?: string;
};

type DateRangeChange = {
  startDate?: Date | null;
  endDate?: Date | null;
};

export const DateUrl = ({
  selectedValues = '..',
  onChangeDate,
  ...props
}: DateUrlProps) => {
  const [startDateString = '', endDateString = ''] = selectedValues.split('..');

  const selectedStartDate = parseDateFromUrl(startDateString);
  const selectedEndDate = parseDateFromUrl(endDateString);

  const handleDateChange = (change: DateRangeChange) => {
    const { startDate, endDate } = change;
    if (!startDate && !endDate) {
      // dates reset / filters removed
      onChangeDate(undefined);
      return;
    }

    const formattedStartDate = formatDateToUrl(startDate);
    const formattedEndDate = formatDateToUrl(endDate);

    onChangeDate(`${formattedStartDate}..${formattedEndDate}`);
  };

  return (
    <DateRangePicker
      triggerProps={{ style: { width: '100%' } }}
      // allowSameStartAndEndDate - Mission control Api does not support
      startDate={selectedStartDate}
      endDate={selectedEndDate}
      onChange={handleDateChange}
      {...props}
    />
  );
};
